import React from 'react';


import component, {classnames} from '../component';
import TopBanner from '../TopBanner';
import TopHeader from '../TopHeader';
import {NewsItem} from './News';
import {HBox, VBox} from '../Box';
import SubNav from '../SubNav';
import LoadMoreButton from '../LoadMoreButton';
import Api from '../../api';


const NewsList = component('NewsList', ({data, params, query}) => {

  async function loadMore() {
    data.setIn(['news', 'loading'], true);
    await Api.news(data, params, query);
    data.setIn(['news', 'loading'], false);
  }

  const newsList = data.getIn(['news', 'list']);
  const mainNewsData = newsList.first();
  const secondaryNews = newsList.shift().map((item)=>(<NewsItem key={item.get('id')} type='List' data={item}/>))

  return <div className='NewsList'>
    <VBox width={4}>
      <HBox isContainer={true} width={4}>
        <NewsItem type='Main' data={mainNewsData}/>
      </HBox>
      <HBox isContainer={true} width={4}>
        <div className="NewsList--Wrap">
          {secondaryNews}
        </div>
      </HBox>
      {!data.getIn(['news', 'noMore']) &&
        <LoadMoreButton onClick={loadMore} text="новостей"
                        loading={data.getIn(['news', 'loading'])} />
      }
    </VBox>
  </div>

}, () =>

  <div className='NewsList--loading'>
    <HBox width={4} height={256}></HBox>
    <HBox width={4}>
      <VBox height={256}></VBox>
      <VBox height={256}></VBox>
    </HBox>
  </div>

);


export default component('NewsHome', function({data, params}) {

  const subNav = data.getIn(['nav'])
      .find(x => x.get('name') === 'newsHome')
      .get('children');

  return (
    <div>
      <TopBanner size='small'>
        <TopHeader justifyCenter >Новости</TopHeader>
      </TopBanner>
      {
        data.getIn(['news', 'list']) && <NewsList data={data} />
      }
    </div>
  );

});



// WEBPACK FOOTER //
// ./src/components/pages/NewsHome.js